import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';

class AppOverview extends Component {
  render() {
    return (
      <Typography noWrap>{'You think water moves fast? You should see ice.'}</Typography>
    )
  }
}

export default AppOverview


// WEBPACK FOOTER //
// ./src/components/AppOverview/AppOverview.jsx